import { useRef, useState, useEffect } from "react";

import styles from "./AutoToggle.module.css";

interface AutoToggleProps {
  enabled: boolean;
  onToggle: () => void;
}

export const AutoToggle = ({ enabled, onToggle }: AutoToggleProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const popoverRef = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (isHovered && wrapperRef.current && popoverRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      popoverRef.current.style.right = `${window.innerWidth - rect.right}px`;
      popoverRef.current.style.bottom = `${window.innerHeight - rect.top + 8}px`;
    }
  }, [isHovered]);

  return (
    <div
      ref={wrapperRef}
      className={styles.autoToggleWrapper}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className={`${styles.autoToggle} ${enabled ? styles.enabled : styles.disabled}`}
        onClick={onToggle}
      >
        <span
          className={`${styles.autoText} ${enabled ? styles.enabled : styles.disabled}`}
        >
          AutoNav
        </span>
        <div
          className={`${styles.toggleThumb} ${enabled ? styles.enabled : styles.disabled}`}
        />
      </div>
      <div
        ref={popoverRef}
        className={`${styles.popover} ${isHovered ? styles.visible : ""}`}
      >
        {enabled
          ? 'Automatic navigation is enabled. This allows AI Chat to navigate to the visualizer or other pages when asked questions like "Show me the CPU Load plot."'
          : "Automatic navigation is disabled. This means AI Chat may render clickable links to plots and other Roboto pages, but will not open them automatically."}
      </div>
    </div>
  );
};
